import { render } from "./ReaderFile.vue?vue&type=template&id=913ba99c&scoped=true"
import script from "./ReaderFile.vue?vue&type=script&lang=js"
export * from "./ReaderFile.vue?vue&type=script&lang=js"

import "./ReaderFile.vue?vue&type=style&index=0&id=913ba99c&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-913ba99c"]])

export default __exports__